import React from 'react';
import XeroSyncButton from './XeroSyncButton';
import { useContactSync } from './useContactSync';

export const XeroContactSync = () => {
  const { startXeroSync, loading } = useContactSync({});

  return <XeroSyncButton onClick={startXeroSync} loading={loading} />;
};
